import { render, staticRenderFns } from "./GroupUserExamResultHistoryPage.vue?vue&type=template&id=88af10f8&"
import script from "./GroupUserExamResultHistoryPage.vue?vue&type=script&lang=ts&"
export * from "./GroupUserExamResultHistoryPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
